import Axios from "axios";

const SERVERLESS_ENGINE = process.env.REACT_APP_AWS_SERVERLESS;

export async function getYoutube(token, setFetchState, state) {
  try {
    let data = await Axios.get(
      `${SERVERLESS_ENGINE}/users/youtubechannel?token=${token}`,
    );

    if (data.status === 200) {
      setFetchState({
        data: data?.data?.youtubeChannels,
        loading: true,
        error: false,
        initialFetchDone: true,
        saveComplete: false,
        errorType: "",
      });
    } else {
      setFetchState({ loading: false, error: true, errorType: "get" });
    }
  } catch (e) {
    setFetchState({ loading: false, error: true, errorType: "get" });
  }
}

export async function deleteYoutube(value, token, state, setState) {
  try {
    let error = false;
    let query = `token=${token}&channel=${value}`;
    try {
      const opt = {
        method: "DELETE",
        url: `${SERVERLESS_ENGINE}/users/youtubechannel?${query}`,
        headers: { "Content-Type": "application/json" },
      };
      let data = await Axios(opt);
      if (!data.response === 200) error = true;
    } catch (e) {
      return setState({
        ...state,
        loading: false,
        error: true,
        errorType: "delete",
      });
    }

    if (!error) {
      return setState({ ...state, saveComplete: true });
    } else {
      return setState({
        ...state,
        loading: false,
        error: true,
        errorType: "save",
      });
    }
  } catch (e) {
    setState({ ...state, loading: false, error: true, errorType: "save" });
  }
}

export async function patchYoutube(values, token, state, setState) {
  try {
    let error = false;
    let query = `token=${token}`;
    try {
      const opt = {
        method: "PATCH",
        url: `${SERVERLESS_ENGINE}/users/youtubechannel?${query}`,
        data: { channel: values },
        headers: { "Content-Type": "application/json" },
      };
      let data = await Axios(opt);
      if (!data.response === 200) error = true;
    } catch (e) {
      return setState({
        ...state,
        loading: false,
        error: true,
        errorType: "save",
      });
    }

    if (!error) {
      return setState({ ...state, saveComplete: true });
    } else {
      return setState({
        ...state,
        loading: false,
        error: true,
        errorType: "save",
      });
    }
  } catch (e) {
    setState({ ...state, loading: false, error: true, errorType: "save" });
  }
}
